<template>
  <van-overlay :show="visible" class="overlay">
    <div class="modal">
      <img src="@/assets/lucky/boom.png" alt="" class="boom" />
      <img src="@/assets/lucky/packet.png" alt="" class="packet" />
      <img src="@/assets/lucky/close.png" alt="" class="close" @click="close" />
      <div class="title">恭喜中奖啦！</div>
      <div class="desc">奖品可在 我的参与记录 中查看</div>
      <div class="btn" @click="$router.push('/lucky/record')">立即查看</div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("visibleChange", false);
    },
  },
};
</script>

<style lang="less" scoped>
.overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal {
  background: #fff;
  width: 28rem;
  padding: 5.7rem 1.2rem 2.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: linear-gradient(39deg, #ffece6 0%, #fff7f4 56%, #fef9f3 100%);
  border-radius: 1.2rem;
  border: 0.1rem solid #ffd9b7;

  .boom {
    position: absolute;
    width: 20.8rem;
    height: 21.1rem;
    top: -8.8rem;
    z-index: -1;
  }

  .packet {
    position: absolute;
    width: 10.8rem;
    height: 7.1rem;
    top: -3.5rem;
  }

  .close {
    position: absolute;
    width: 2.4rem;
    height: 2.4rem;
    bottom: -2rem - 2.4rem;
  }

  .title {
    font-size: 1.8rem;
    font-weight: 700;
    color: #4a1500;
  }

  .desc {
    font-size: 1.2rem;
    color: #885a47;
    margin-top: 0.4rem;
  }

  .btn {
    width: 10.8rem;
    height: 3.6rem;
    background: linear-gradient(180deg, #ffabc8 0%, #ff4a82 15%, #fb2553 100%);
    border-radius: 1.8rem;
    border: 0.1rem solid #ffd9b7;
    font-size: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 700;
    margin-top: 1.9rem;
  }
}
</style>
